import { ArrowUDownRightIcon } from './ArrowUDownRightIcon';

/**
 * author: Colton Wiscombe
 * id C2A75394-FCF6-4BFB-868F-3FC14C48B6FC
 * name arrow-u-down-right
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-u-down-right.svg
 * tags
 */
export const UTurnRightIcon = ArrowUDownRightIcon;
export default UTurnRightIcon